import {
  NUTRIENTS_ENUM,
  NutrientType,
} from '../../../../shared/constants/NUTRIENTS_ENUM';

export const FOOD_FORM_NUTRIENTS = [
  NUTRIENTS_ENUM.PROTEINS,
  NUTRIENTS_ENUM.CARBS,
  NUTRIENTS_ENUM.FATS,
  NUTRIENTS_ENUM.SUGAR,
  NUTRIENTS_ENUM.FIBER,
  NUTRIENTS_ENUM.VEGGIES,
  NUTRIENTS_ENUM.SODIUM,
] as const satisfies NutrientType[];

export type FoodFormNutrient = (typeof FOOD_FORM_NUTRIENTS)[number];

export const NUTRIENT_ROUNDING_PRECISION: number = 3;
